import { render, staticRenderFns } from "./LinkUnico.vue?vue&type=template&id=2167a12d&"
import script from "./LinkUnico.vue?vue&type=script&lang=js&"
export * from "./LinkUnico.vue?vue&type=script&lang=js&"
import style0 from "./LinkUnico.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinkUnico.vue"
export default component.exports